<template>
  <div class="body">
    <div class="title">
      查看详情
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf">
            首页
          </span></el-breadcrumb-item>
          <el-breadcrumb-item class="dsadf" >信息管理</el-breadcrumb-item>
          <el-breadcrumb-item class="dsadf" :to="{ path: '/yijianfankui' }">意见反馈</el-breadcrumb-item>
          <el-breadcrumb-item>查看详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <el-card  class="cardpsad">
      <el-row>
        <el-col :span="12">
          <div class="fromdsadas">
            <div class="tiile">
              举报信息
            </div>
            <div>
              <el-form class="demo-form-inline" :label-position="labelPosition" @submit.native.prevent>
                <el-form-item label="反馈者" label-width="116px">
                  <div class="flexsaa">
                  {{ Query.realname}}
                  <button class="huiyuanziliao" @click="openhuiyuan">会员资料</button>
                  </div>
                </el-form-item>
                <el-form-item label="反馈图片" label-width="116px">
                  <div class="fromcc">
                    <div class="imgscc" v-for="(item, index) in Query.feedback_pics" :key="index">
                      <img :src="item.name" alt="" class="imgscc">
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="反馈描述" label-width="116px">
                    {{Query.feedback_content}}
                </el-form-item>
                <el-form-item label="联系人" label-width="116px">
                  {{ Query.realname}}
                </el-form-item>
                <el-form-item label="联系电话" label-width="116px">
                  <div class="wenbenyu">
                    {{ Query.feedback_mobile }}
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <div class="rou">
              <button  @click="tongguoshenqing()"  class="tongguo" >
                <i class="el-icon-check"></i>
                受理反馈</button>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="fromdsadas">
            <div class="tiile">
              状态信息
            </div>
            <el-form class="demo-form-inline" :label-position="labelPosition" @submit.native.prevent>
              <el-form-item label="提交时间 " label-width="116px">
                {{Query.sub_time }}
              </el-form-item>
              <el-form-item label="受理状态" label-width="116px">
                <span  :style="{'color': (Query.is_status === 0 ? '#cccccc':'#0FA838')}">
                  {{Query.is_status === 0?'待受理':'已受理' }}
                </span>
              </el-form-item>
              <el-form-item label="受理时间" label-width="116px">
                {{Query.apply_mobile }}
              </el-form-item>
              <el-form-item label="受理情况备注" label-width="116px">
                <div class="flexsaa">
                  {{ Query.status_remark}}
                  <button class="huiyuanziliao" @click="xiugai">修改</button>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <vxe-modal width="579" ref="huiyuan" height="622" size="small" :show-footer="false" title="会员资料" :show-close="true">
      <div class="huiyuan">
        <el-form class="demo-form-inline" :label-position="labelPosition" style="margin-top: 60px; margin-left: 60px">
          <el-form-item label="头像" label-width="116px">
            <div class="flexsaa">
              <img :src="Query.facepic" alt="" class="imgs">
            </div>
          </el-form-item>
          <el-form-item label="姓名" label-width="116px">
            <div class="flexsaa">
              {{Query.realname}}
            </div>
          </el-form-item>
          <el-form-item label="手机号码" label-width="116px">
            <div class="flexsaa">
              {{Query.usermobile}}
            </div>
          </el-form-item>
          <el-form-item label="注册时间" label-width="116px">
            <div class="flexsaa">
              {{Query.userregtime}}
            </div>
          </el-form-item>
          <el-form-item label="发帖数" label-width="116px">
            <div class="flexsaa">
              {{Query.userpostnum}}
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vxe-modal>
    <vxe-modal  width="336" ref="tongguo" height="182" size="small" :show-footer="false" :showHeader="false" :show-close="true">
      <div class="popchuangkou">
        <img src="../../assets/img/closeaaaa.png" alt="" class="dsff" @click="routeClose">
        <div class="titledd" style="margin-bottom: 20px">
          受理反馈
        </div>
        <vxe-input v-model="remark" placeholder="请输入受理情况备注(非必填)" style="width: 200px;height: 50px"></vxe-input>
        <div class="bobox">
          <button class="queren" @click="openqueren">
            确认
          </button>
          <button class="quxiao"  @click="routeClose">
            取消
          </button>
        </div>
      </div>
    </vxe-modal>
    <vxe-modal  width="336" ref="xiugai" height="182" size="small" :show-footer="false" :showHeader="false" :show-close="true">
      <div class="popchuangkou">
        <img src="../../assets/img/closeaaaa.png" alt="" class="dsff" @click="routexiugaiclosee">
        <div class="titledd mbP">
          修改受理情况备注
        </div>
        <vxe-input v-model="remark" placeholder="请输入受理情况备注(非必填)" style="width: 200px;height: 50px"></vxe-input>
        <div class="bobox">
          <button class="queren" @click="openbeizhu">
            确认
          </button>
          <button class="quxiao"  @click="routexiugaiclosee">
            取消
          </button>
        </div>
      </div>
    </vxe-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { feedbackView, feedbackSetstatusval, feedbackSubremark } from '@/api/xinxi'
export default {
  name: 'index',
  computed: {
    // ...mapState(['yijianID'])
  },
  created () {
    this.yijianID = this.$route.query.id || "";
    this.xiangqing()
  },
  data () {
    return {
      labelPosition: 'left',
      Query: {},
      pic: [],
      remark: ''
    }
  },
  methods: {
    routexiugaiclosee () {
      this.$refs.xiugai.close()
    },
    openbeizhu () {
      const obj = {
        token: sessionStorage.getItem('token'),
        id: this.yijianID,
        remark: this.remark
      }
      feedbackSubremark(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
          this.$refs.xiugai.close()
          this.xiangqing()
        }
      })
    },
    xiugai () {
      this.$refs.xiugai.open()
    },
    openhuiyuan () {
      this.$refs.huiyuan.open()
    },
    openqueren () {
      const obj = {
        token: sessionStorage.getItem('token'),
        ids: this.yijianID,
        remark: this.remark
      }
      feedbackSetstatusval(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
          this.$refs.tongguo.close()
          this.xiangqing()
        }
      })
    },
    tongguoshenqing () {
      this.$refs.tongguo.open()
    },
    routeClose () {
      this.$refs.tongguo.close()
    },
    Pushjujue () {
      this.$refs.jujue.open()
    },
    routeClosecc () {
      this.$refs.jujue.close()
    },
    xiangqing () {
      const obj = {
        token: sessionStorage.getItem('token'),
        id: this.yijianID
      }
      feedbackView(obj).then(({ data: res }) => {
        console.log('resss', res)
        this.Query = res
      })
    }
  }
}
</script>

<style scoped lang="less">
.flexsaa{
  display: flex;
  flex-direction: row;
  align-items: center;
  .huiyuanziliao{
    margin-left: 13px;
    width: 78px;
    height: 37px;
    opacity: 1;
    border: 1px solid rgba(61,154,255,0.50);
    background: white;
    border-radius: 2px;
    opacity: 1;
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #3d9aff;
    letter-spacing: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.fromcc{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
}
.imgscc{
  width: 100px;
  height: 100px;
}
.popchuangkou{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  .mbP{
    margin-bottom: 24px;
  }
  .dsff{
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
  }
  .titledd{
    margin-top: 22px;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 500;
    text-align: left;
    color: #2e2e2e;
  }
  .einput{
    width: 253px;
    height: 44px;
    opacity: 1;
    background: #fbfbfb;
    border-radius: 5px;
  }
  .bobox{
    margin-top: 43px;
    display:flex;
    flex-direction: row;
    align-items: center;
  }
  .queren{
    width: 95px;
    height: 36px;
    opacity: 1;
    background: linear-gradient(135deg,#3d9aff, #3380f2);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    margin-right: 12px;
  }
  .quxiao{
    width: 95px;
    height: 36px;
    opacity: 1;
    background: rgba(61,154,255,0.10);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #3d9aff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
  }
}
.tongguo{
  width: 124px;
  height: 44px;
  opacity: 1;
  background: linear-gradient(135deg,#1bb745, #17ab3f);
  border-radius: 5px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  border: none;
}
.mb{
  margin-right: 10px;
}
.jujue{
  border: none;
  width: 124px;
  height: 44px;
  opacity: 1;
  background: linear-gradient(135deg,#e54848, #d54141);
  border-radius: 5px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}
.rou{
  display:flex;
  flex-direction: row;
}
.fxrowccsaa{
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  width: 400px;
  .imgsccccss{
    width: 100px;
    height: 100px;
    margin-right: 20px;
    margin-bottom: 20px;
    display: inline-block;
    .imgscc33{
      width: 100%;
      height: 100%;
    }
  }
}

.body {
  display: flex;
  flex-direction: column;
  .cardpsad{
    padding:40px 50px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
  }
  .wenbenyu{
    width: 370px;
  }
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }

    .dsadf {
      color: #3D9AFF;
    }

  }
  .fromdsadas{
    display:flex;
    flex-direction: column;
    .tiile{
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Heavy;
      font-weight: 800;
      text-align: left;
      color: #2e2e2e;
      letter-spacing: 0px;
      margin-bottom: 42px;
    }
  }
}
</style>
